import { render, staticRenderFns } from "./ParticipantSettings.vue?vue&type=template&id=26d47ec4&"
import script from "./ParticipantSettings.vue?vue&type=script&lang=ts&"
export * from "./ParticipantSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports